import { StructuredEvacuationsEditLayerProps } from './types';

export const SOURCE_ID = 'evac_zones_ca';

export const EVAC_ZONES_EDIT_FILL_LAYER_ID = 'zones-edit-fill';
export const EVAC_ZONES_EDIT_STROKE_LAYER_ID = 'zones-edit-stroke';
export const EVAC_ZONES_EDIT_LABEL_LAYER_ID = 'zones-edit-label';
export const EVAC_ZONES_EDIT_PATTERN_LAYER_ID_PREFIX = 'zones-edit-pattern';

export const VIEW_SOURCE_ID = `${SOURCE_ID}_VIEW`;

// always show with minzoom at 1
export const ACTIVE_ZONES_LAYER_MIN_ZOOM = 1;
export const INACTIVE_ZONES_LAYER_MIN_ZOOM = 9;
export const LABEL_LAYER_MIN_ZOOM = 9;

export const EVAC_ZONES_EDIT_LAYER_ID_PREFIX = 'zones-edit';
export const EVAC_ZONES_VIEW_FILL_LAYER_ID = 'zones-view-fill';
export const EVAC_ZONES_VIEW_STROKE_LAYER_ID = 'zones-view-stroke';
export const EVAC_ZONES_VIEW_LABEL_LAYER_ID = 'zones-view-label';
export const EVAC_ZONES_VIEW_PATTERN_LAYER_ID = 'zones-view-pattern';

export const ZONES_SOURCE_LAYER = 'evaczones';
export const LABELS_SOURCE_LAYER = 'evaczone_labels';

export const FEATURE_UID_V2_FIELD_NAME = 'uid_v2';

export const EVAC_ZONES_SOURCE_LAYER_NAME = 'evaczones,evaczone_labels';

export const PENDING_EVAC_ZONES_SOURCE_ID = 'pending_evaczones';
export const PENDING_EVAC_ZONES_SOURCE_LAYER_NAME =
  'pending_evaczones,pending_evaczone_labels';
export const PENDING_ZONES_SOURCE_LAYER = 'pending_evaczones';
export const PENDING_ZONES_LABELS_SOURCE_LAYER = 'pending_evaczone_labels';

export const PENDING_EVAC_ZONES_EDIT_LAYER_ID_PREFIX = 'zones-edit-pending';

export const STRUCTURED_EVAC_EDIT_LAYER_DEFAULT_PROPS: Omit<
  StructuredEvacuationsEditLayerProps,
  'visible' | 'evacZones'
> = {
  sourceId: SOURCE_ID,
  layerName: EVAC_ZONES_SOURCE_LAYER_NAME,
  zoneSourceLayer: ZONES_SOURCE_LAYER,
  labelSourceLayer: LABELS_SOURCE_LAYER,
  zoneLayerPrefix: EVAC_ZONES_EDIT_LAYER_ID_PREFIX,
  zoneLayerFillPrefix: EVAC_ZONES_EDIT_FILL_LAYER_ID,
};

export const STRUCTURED_EVAC_PENDING_LAYER_DEFAULT_PROPS: Omit<
  StructuredEvacuationsEditLayerProps,
  'visible' | 'evacZones'
> = {
  sourceId: PENDING_EVAC_ZONES_SOURCE_ID,
  layerName: PENDING_EVAC_ZONES_SOURCE_LAYER_NAME,
  zoneSourceLayer: PENDING_ZONES_SOURCE_LAYER,
  labelSourceLayer: PENDING_ZONES_LABELS_SOURCE_LAYER,
  zoneLayerPrefix: PENDING_EVAC_ZONES_EDIT_LAYER_ID_PREFIX,
};
